//请自行添加语言资源
const soldTo = {
  areaName:'区域名称',
  customerNo:'客户编号',
  city:'城市',
  areaCode:'区域编号',
  district:'街道',
  soldtoNoTemp: '售达方编号',
  soldtoName:'售达方名称',
  postcode:'邮政编码',
  tel:'电话',
  delStatus:'删除标记',
  fax:'传真',
  soldtoNo:'售达方编码',
  frozenState:'冻结状态',
  credit: '是否为信贷',
  mtoFlag: '是否允许下MTO',
  minimumOrderlimit: '最小起订量设置',
  customerGroup: '客户组',
  msg:{
  }
};
export default soldTo



// WEBPACK FOOTER //
// ./src/page/md/soldTo/lang/soldTo.zh.js